import { Box } from "../Box"

import { FlagImg } from "./FlagImg"
import { FlagHex } from "./FlagHex"
import { FlagSquare } from "./FlagSquare"

export const Flag = ({
  variant = "default",
  name,
  size: initialSize = [36],
  borderWidth = 0,
  borderColor = "gray.100",
}) => {
  const ratio = 4 / 3

  // size determines the height of rectangle and width of square
  // width of the rectangle is determined by the ratio
  const size = Array.isArray(initialSize) ? initialSize : [initialSize]
  const height = size.map(s =>
    typeof s === "number" ? s - borderWidth * 2 : s
  )
  const width =
    variant === "default"
      ? height.map(h => (typeof h === "number" ? h * ratio : h))
      : height

  const props = {
    name,
    width,
    height,
    borderWidth,
    borderColor,
    ratio,
    borderRadius: variant === "circle" ? "full" : undefined,
  }

  if (variant === "hex") return <FlagHex {...props} />
  else if (["square", "circle"].includes(variant))
    return <FlagSquare {...props} />
  return (
    <Box
      width={width.map(w => (typeof w === "number" ? `${w}px` : w))}
      borderWidth={borderWidth}
      borderColor={borderColor}
    >
      <FlagImg {...props} />
    </Box>
  )
}
